export class EntityMetadataBuilder {

}
